import { render } from "./CheckboxSingle.vue?vue&type=template&id=19a805fc"
import script from "./CheckboxSingle.vue?vue&type=script&lang=js"
export * from "./CheckboxSingle.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Express\\北方\\Agent_SYSTEM\\AgentWeb\\Vue\\agentweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__